import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Day } from 'lumen/models';

const OUTLIER_STATUS_DISCARDED = 1;

interface OutlierData {
  destination_rate_index: number;
  destination_rate_index_dow: number;
  rate_index: number;
  rate_index_dow: number;
  smart_compset_rate_index: number;
  smart_compset_rate_index_dow: number;
}

export default class Outlier extends Model {
  [Type] = 'outlier' as const;

  @belongsTo('day', { async: false, inverse: 'outliers' })
  declare day: Day;

  @attr('number') declare category: number;
  @attr() declare data: OutlierData;
  @attr('number') declare status: number;
  @attr('number') declare value: number;

  @service declare intl: Services['intl'];

  get formattedValue(): string {
    return `${this.value > 0 ? '+' : ''}${Math.round(this.value * 100)}%`;
  }

  get formattedValueString(): {
    long: string;
    short: string;
  } {
    if (this.value >= 0) {
      return {
        long: this.intl.t('market_insight.opportunities.rate.high'),
        short: this.intl.t('market_insight.opportunities.rate.high_short'),
      };
    }

    return {
      long: this.intl.t('market_insight.opportunities.rate.low'),
      short: this.intl.t('market_insight.opportunities.rate.low_short'),
    };
  }

  get isDiscarded(): boolean {
    return this.status === OUTLIER_STATUS_DISCARDED;
  }
}
